import { RestUrl } from "../common/cyan.types";

export class FolderUrl {
  public static paginateFolders: RestUrl = ["GET", "/folders"];
  public static getFoldersSummary: RestUrl = ["GET", "/folders/get-summary"];
  public static browseFolders: RestUrl = ["GET", "/folder/browse"];
  public static getFolderById: (folderId: bigint) => RestUrl = id => ["GET", `/folders/${id}`];
  public static createFolder: RestUrl = ["POST", "/folders"];
  public static removeFolderById: (folderId: bigint) => RestUrl = id => ["DELETE", `/folders/${id}`];
  public static moveFolderById: (folderId: bigint) => RestUrl = id => ["POST", `/folders/${id}/move`];
  public static renameFolderById: (folderId: bigint) => RestUrl = id => ["POST", `/folders/${id}/rename`];
  public static getMyRoleForFolderById: (folderId: bigint) => RestUrl = id => ["GET", `/folders/${id}/my-role`];
  public static getMyRoleForFolderFileById: (fileId: bigint) => RestUrl = id => ["GET", `/folder/files/${id}/my-role`];
}
